import {
  eventBus,
  INTERNAL_EVENTS,
  useConfigStore,
} from '@cometchat/calls-sdk-core';
import { useEffect, useState } from 'react';
import Notification, { type NotificationProps } from './Notification.web';

const NotificationContainer = () => {
  const [notifications, setNotifications] = useState<
    Pick<NotificationProps, 'message' | 'type' | 'id' | 'autoCloseDelay'>[]
  >([]);
  const iAmRecorder = useConfigStore(state => state.iAmRecorder);

  const addNotification = (
    notification: Pick<NotificationProps, 'message' | 'type'>,
  ) => {
    console.log(
      'NotificationContainer addNotification',
      Math.max((notification.message.length / 17) * 1000, 2000),
    );
    setNotifications(prev => [
      ...prev.slice(-4),
      {
        ...notification,
        id: Date.now().toString(36),
        autoCloseDelay: Math.max(
          Math.min((notification.message.length / 17) * 1000, 6000),
          2000,
        ),
      },
    ]);
  };

  useEffect(() => {
    if (iAmRecorder) {
      return;
    }
    const unsubscribe = eventBus.subscribe(
      INTERNAL_EVENTS.notification,
      payload => {
        addNotification({
          message: payload.message,
          type: payload.type,
        });
      },
    );

    return unsubscribe;
  }, [iAmRecorder, notifications]);

  return (
    <div
      style={{
        position: 'absolute',
        bottom: 70,
        left: 20,
        display: 'flex',
        flexDirection: 'column-reverse',
        gap: 10,
      }}>
      {notifications.map(notification => (
        <Notification
          key={notification.id}
          id={notification.id}
          message={notification.message}
          type={notification.type}
          autoCloseDelay={notification.autoCloseDelay}
        />
      ))}
      {/* <Notification
        message="This is a notification message for testing purposes."
        buttonText="Close"
        buttonAction={() => console.log('Close clicked')}
        type="info"
      />
      <Notification
        message="This is a notification message and it is important and very long lorem ipsum dolor sit amet, consectetur adipiscing elit."
        buttonText="Close"
        buttonAction={() => console.log('Close clicked')}
        type="success"
      />
      <Notification
        message="This is a notification message."
        buttonText="Close"
        buttonAction={() => console.log('Close clicked')}
        type="warning"
      />
      <Notification
        message="This is a notification message."
        buttonText="Close"
        buttonAction={() => console.log('Close clicked')}
        type="error"
      /> */}
    </div>
  );
};

export default NotificationContainer;
